import React from 'react'
import { Row, Col, Typography, theme } from 'antd'
import { MedicineBoxOutlined } from '@ant-design/icons'
import useTheatreData from '../hooks/useTheatreData'
import SummaryCards from './SummaryCards'
import TheatreCard from './TheatreCard'

const { Title, Text } = Typography

const TheatreView = () => {
  const { token } = theme.useToken()
  const { theatres, currentTime, activeTheatres, idleTheatres, cleaningTheatres, totalProcedures } = useTheatreData()

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' }}>
          <MedicineBoxOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
          <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
            Theatre Dashboard
          </Title>
        </div>
        <Text type='secondary'>Last updated: {currentTime.toLocaleTimeString()}</Text>
      </div>

      {/* Summary Cards */}
      <SummaryCards
        activeTheatres={activeTheatres}
        idleTheatres={idleTheatres}
        cleaningTheatres={cleaningTheatres}
        totalProcedures={totalProcedures}
        totalTheatres={theatres.length}
      />

      {/* Theatre Cards */}
      <Row gutter={[16, 16]}>
        {theatres.map((theatre) => (
          <Col xs={24} md={12} lg={8} key={theatre.theatreId}>
            <TheatreCard theatre={theatre} />
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default TheatreView
